import { render } from "./BlueFlower.svg?vue&type=template&id=970430b8"
const script = {}
script.render = render

export default script